import { useMediaQuery } from '@mui/material'
import { useTheme } from 'styled-components'

export type ThemeMediaQueryKey =
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'nav'
  | 'xsMobile'
  | 'mobile'
  | 'tablet'
  | 'desktop'

const STRIP_MEDIA_PREFIX = /^@media\s+screen\s+and\s+/i

/**
 * MUI `useMediaQuery` expects a raw media condition like `(max-width: 900px)`.
 * Styled-components theme `mediaQueries.*` strings include `@media screen and` for CSS blocks;
 * passing those directly to MUI breaks responsive layout (everything uses wrong breakpoint).
 */
export function useThemeMediaQuery(key: ThemeMediaQueryKey): boolean {
  const theme = useTheme() as { mediaQueries: Record<ThemeMediaQueryKey, string> }
  const block = theme.mediaQueries[key]
  const query = STRIP_MEDIA_PREFIX.test(block) ? block.replace(STRIP_MEDIA_PREFIX, '').trim() : block
  return useMediaQuery(query)
}
